import request from '@/utils/request'

let MinistoreApi = {
  /*商品列表*/
  productList(data, errorback) {
      return request._post('/shop/ministore.product/index', data, errorback);
  },
  /*添加商品*/
  addProduct(data, errorback) {
      return request._post('/shop/ministore.product/add', data, errorback);
  },
  /*获取详情*/
  getProduct(data, errorback) {
      return request._get('/shop/ministore.product/add', data, errorback);
  },
  /*获取商品*/
  getMinistoreProduct(data, errorback) {
      return request._get('/shop/ministore.product/edit', data, errorback);
  },
  /*编辑商品*/
  editMinistoreProduct(data, errorback) {
      return request._post('/shop/ministore.product/edit', data, errorback);
  },
  /*删除商品*/
  deleteProduct(data, errorback) {
      return request._post('/shop/ministore.product/delete', data, errorback);
  },
  /*上架商品*/
  listingProduct(data, errorback) {
      return request._post('/shop/ministore.product/listing', data, errorback);
  },
  /*下架商品*/
  delistingProduct(data, errorback) {
      return request._post('/shop/ministore.product/delisting', data, errorback);
  },
  /*撤回审核*/
  delauditProduct(data, errorback) {
      return request._post('/shop/ministore.product/delaudit', data, errorback);
  },

  shopCatlist(data, errorback) {
    return request._post('/shop/ministore.shopCat/index', data, errorback);
  },
  /*类目申请*/
  shopcatApply(data, errorback) {
    return request._post('/shop/ministore.shopCat/shopcatApply', data, errorback);
  },

  enabled(data, errorback) {
    return request._post('/shop/ministore.shopCat/enabled', data, errorback);
  },

  synShopCat(data, errorback) {
    return request._post('/shop/ministore.shopCat/synShopCat', data, errorback);
  },

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/ministore.setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/ministore.setting/index', data, errorback);
  },

}
export default MinistoreApi;



// WEBPACK FOOTER //
// ./src/api/ministore.js